import ReCAPTCHA from "react-google-recaptcha";
import React from "react";

function InvisibleRecaptcha({Child}) {
  const recaptchaRef = React.useRef(null);

  async function getToken() {
    return await recaptchaRef.current.executeAsync()
  }

  return (
    <>
      <ReCAPTCHA ref={recaptchaRef} sitekey={window.config.FULFILLMENT_RECAPTCHA_SITE_KEY} size='invisible'/>
      <Child getRecaptchaToken={getToken} />
    </>
  )
}

export default InvisibleRecaptcha;
